import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'tisa-season-table-live-match-result',
  templateUrl: './season-table-live-match-result.component.html',
  styleUrls: ['./season-table-live-match-result.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SeasonTableLiveMatchResultComponent {
  //TODO : move component live-result from esa repo after merge this PR #970
}
